import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DoctorsAvailApi } from '../api/doctors-avail.api';
import { switchMap, map } from 'rxjs/operators';
import { DoctorsAvailData, DoctorsAvail } from '../../../interfaces/patient-services/doctors-avail';

@Injectable()
export class DoctorsAvailService extends DoctorsAvailData {

  constructor(private api: DoctorsAvailApi) {
    super();
  }


  list(url: string): Observable<DoctorsAvail[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<DoctorsAvail>{
      return this.api.getById(url);
  }

  create(url: string, data:DoctorsAvail): Observable<DoctorsAvail> {
    return this.api.add(url,data);
  }

  bulkUpdate(url: string, data:DoctorsAvail[]): Observable<DoctorsAvail> {
    return this.api.bulkUpdate(url,data);
  }

  update(url: string, data:DoctorsAvail): Observable<DoctorsAvail> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
